<script>
  import { Toaster, toast } from 'svelte-sonner';
  import { page, Link } from '@inertiajs/svelte'
  import AuthPromoPanel from '@components/general/auth-promo-panel.svelte'
  import CookieConsentBanner from '@components/general/cookie-consent-banner.svelte'

  let { children } = $props();

  $effect(() => {
    if ($page.props.flash.notice) { toast.success($page.props.flash.notice) }
    if ($page.props.flash.alert) { toast.error($page.props.flash.alert) }
  })
</script>

<div class="flex flex-col lg:flex-row lg:h-screen bg-white">
  
  <main class="flex min-h-0 flex-1 flex-col items-stretch px-8 lg:overflow-y-auto">
    <div class="flex min-h-0 flex-1 flex-col justify-center w-full max-w-120 mx-auto py-12">
      {@render children?.()}
    </div>

    <div class="flex justify-center gap-3 pb-6 text-xs text-gray-400">
      {#each $page.props.signup_pages ?? [] as sp}
        <Link href="/{sp.slug}" class="hover:text-gray-600 underline underline-offset-2">{sp.title}</Link>
      {/each}
      <CookieConsentBanner showTrigger />
    </div>
  </main>

  <aside class="hidden lg:flex lg:w-[clamp(440px,40vw,640px)] p-3">
    <AuthPromoPanel />
  </aside>
</div>

<Toaster position="top-right" />
<CookieConsentBanner />
